"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFSC_TB = 'ifsc_tb';
exports.IFSC_TZ = 'ifsc_tz';
exports.IFSC_LEAD = 'ifsc_lead';
exports.NORTH_FACE_CUP_2019 = 'north_face_cup_2019';
exports.POINTS_DECREASE = 'points_decrease';
exports.POINTS_GRAVICAL_2019 = 'points_gravical_2019';
exports.TOPS_WITH_ATTEMPTS = 'tops_with_attempts';
exports.USAC_MOD_REDPOINT = 'usac_modified_redpoint';
exports.USAC_MOD_REDPOINT_MULTIZONE = 'usac_modified_redpoint_multizone';
exports.scoreSystemKeys = [
    exports.IFSC_TB,
    exports.IFSC_TZ,
    exports.IFSC_LEAD,
    exports.NORTH_FACE_CUP_2019,
    exports.TOPS_WITH_ATTEMPTS,
    exports.USAC_MOD_REDPOINT,
    exports.USAC_MOD_REDPOINT_MULTIZONE,
];
exports.scoreSystemNames = (_a = {},
    _a[exports.IFSC_TB] = 'IFSC Top-Bonus (before 2018)',
    _a[exports.IFSC_TZ] = 'IFSC Top-Zone (2018 onwards)',
    _a[exports.IFSC_LEAD] = 'IFSC Lead',
    _a[exports.NORTH_FACE_CUP_2019] = 'The North Face Cup 2019',
    _a[exports.TOPS_WITH_ATTEMPTS] = 'Tops with Attempts',
    _a[exports.USAC_MOD_REDPOINT] = 'USAC Modified Redpoint',
    _a[exports.USAC_MOD_REDPOINT_MULTIZONE] = 'USAC Modified Redpoint - Multizone',
    _a);
var _a;
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/constants.js
// module id = 17
// module chunks = 0